import React from "react";
import { Cascader, CascaderProps } from "antd";
import {
  TravelModeOption,
  useGetTravelReferenceOptions,
} from "@/pages/employee/travel_modes/useTravelMode";
import styles from "./TravelModeCascader.module.scss";

function TravelModeCascader({
  urn,
  onChange,
  loading,
}: {
  urn?: string;
  onChange?: (_: any, selectedOptions: TravelModeOption[] | undefined) => void;
  loading?: boolean;
}) {
  const { data, isLoading } = useGetTravelReferenceOptions();

  const displayRender: CascaderProps<TravelModeOption>["displayRender"] = (
    labels,
    selectedOptions = []
  ) =>
    labels.map((label, i) => {
      const option = selectedOptions[i];
      if (i === labels.length - 1) {
        return <span key={option.value}>{label}</span>;
      }
      return <span key={option.value}>{label}, </span>;
    });

  const getPath = (urn: string, options?: TravelModeOption[]): string[] => {
    if (!options) {
      return [];
    }
    for (const option of options) {
      if (option.value === urn) {
        return [option.value];
      }
      if (option.children) {
        const path = getPath(urn, option.children);
        if (path.length) {
          return [option.value, ...path];
        }
      }
    }
    return [];
  };

  return (
    <div className={styles["cascader-container"]}>
      <Cascader
        options={data}
        onChange={onChange}
        placeholder="Please select"
        multiple={false}
        defaultValue={urn ? getPath(urn, data) : undefined}
        popupClassName={styles["popupClassName"]}
        className={styles["travelModeCascader"]}
        displayRender={displayRender}
        loading={isLoading || loading}
      />
    </div>
  );
}

export default TravelModeCascader;
